module.exports = __webpack_public_path__ + "media/MRI22A.dd837eae.mp3";